import classNames from 'classnames';
import styles from './order-status-timeline.module.scss';
import { Tooltip } from '../../../components/tooltip/tooltip';
import { Typography } from '../../../components/typography/typography';

type OrderStatusTimelineProps = {
  entries: OrderStatusTimelineEntry[];
};

type OrderStatusTimelineEntry = {
  text: string;
  tooltip?: string;
  isActive: boolean;
  type?: 'completed' | 'cancelled' | 'missed';
};

export const OrderStatusTimeline = ({ entries }: OrderStatusTimelineProps) => {
  return (
    <div className={classNames(`flex justify-between py-[14px]`, {})}>
      {entries.map((entry, idx) => (
        <StatusItem key={`order-status-timeline-entry-${idx}`} {...entry} />
      ))}
    </div>
  );
};

const StatusItem = ({ text, tooltip, isActive, type }: OrderStatusTimelineEntry) => (
  <div
    className={classNames(styles.orderTracking, {
      [styles.completed]: type === 'completed',
      [styles.cancelled]: type === 'cancelled',
      [styles.missed]: type === 'missed',
    })}
  >
    <Tooltip tooltip={`${text}\n${tooltip}`} type="black" invisible={(tooltip?.length || 0) === 0} allowBreakpoints>
      <span className={classNames(styles.isComplete)}></span>
    </Tooltip>

    <div className="mt-[16px]">
      <Typography
        type="text-sm"
        weight={isActive ? 'medium' : 'regular'}
        className={classNames({
          'text-quipli-black-800': isActive,
          'text-grey-300': !isActive,
        })}
      >
        {text}
      </Typography>
    </div>
  </div>
);
